import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { ADD_TOPIC_I18N_EN } from './locales/en/features/topics/components/add_topic.i18n.en';
import { CHOOSE_DATA_SOURCE_MODAL_I18N_EN } from './locales/en/features/topics/components/choose_data_source_modal.i18n.en';
import { UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_EN } from './locales/en/features/topics/components/upload_data_topic_details_modal.i18n.en';
import { UPLOAD_FILES_MODAL_I18N_EN } from './locales/en/features/topics/components/upload_files_modal.i18n.en';
import { DATA_SUMMARY_MODAL_I18N_EN } from './locales/en/features/topics/components/data_summary_modal.i18n.en';
import { DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_EN } from './locales/en/features/topics/components/data_summary_with_errors_modal.i18n.en';
import { DATA_SUMMARY_SECTION_I18N_EN } from './locales/en/features/topics/components/data_summary_section.i18n.en';
import { ERROR_SECTION_I18N_EN } from './locales/en/features/topics/components/error_section_i18n.en';
import { LOADING_MODAL_I18N_EN } from "./locales/en/features/topics/components/loading_modal.i18n.en";
import { REMOVE_ROWS_CONFIRMATION_MODAL_I18N_EN } from "./locales/en/features/topics/components/remove_rows_confirmation_modal.i18n.en";
import { CANCEL_TOPIC_CREATION_MODAL_I18N_EN } from "./locales/en/features/topics/components/cancel_topic_creation_modal.i18n.en";
import { DATA_TABLE_SECTION_I18N_EN } from "./locales/en/features/topics/components/data_table_section.i18n.en";
import { UPLOADED_FILES_TABLE_SECTION_I18N_EN } from './locales/en/features/topics/components/uploaded_files_table_section.i18n.en';
import { TOPICS_I18N_EN } from './locales/en/features/topics/topics.i18n.en';
import { DASHBOARD_I18N_EN } from './locales/en/features/home/components/dashboard.i18n.en';
import { FILTER_I18N_EN } from './locales/en/features/home/components/filter.i18n.en';
import {
  ADD_USER_ACCOUNT_MODAL_I18N_EN
} from './locales/en/features/user_management/components/add_user_account_modal.i18n.en';
import { CHANGE_PASSWORD_I18N_EN } from './locales/en/features/home/components/change_password.i18n.en';
import { APP_I18N_EN } from './locales/en/features/home/app.i18n.en';
import {RELEVANCE_FILTER_I18N_EN} from './locales/en/features/home/components/comment-filter/relevance_filter.i18n.en'
import { BUBBLE_CHART_I18N_EN } from './locales/en/features/shared_components/chart/bubble_chart.i18n.en'
import { LOGIN_I18N_EN } from './locales/en/features/login/login.i18n.en';
import { RESET_PASSWORD_I18N_EN } from './locales/en/features/login/reset_password.i18n.en';
import { COMMON_I18N_EN } from './locales/en/features/home/components/common.i18n.en';
import { UPLOADED_COMMENTS_TAB_I18N_EN } from './locales/en/features/home/components/uploaded_comments_tab.i18n.en';
import { FEED_COMMENTS_I18N_EN } from './locales/en/features/home/components/feed_comments.i18n.en';
import { EDIT_TOPIC_MODAL_I18N_EN } from './locales/en/features/topics/components/edit_topic_modal.i18n.en';
import { KEYWORDS_DETAILS_SECTION_I18N_EN } from './locales/en/features/topics/components/edit-topic/keywords_details_section.i18n.en';
import { BASIC_TOPIC_DETAILS_SECTION_I18N_EN } from './locales/en/features/topics/components/edit-topic/basic_topic_details_section.i18n.en';
import { COMMON_HTTP_I18N_EN } from './locales/en/common/http.i18n.en';
import { SOURCES_I18N_EN } from './locales/en/features/sources/sources.i18n.en';

const resources = {
  'en': {
    translation: {
      features: {
        login: {
          login: LOGIN_I18N_EN,
          reset_password: RESET_PASSWORD_I18N_EN
        },
        home: {
          components: {
            dashboard: DASHBOARD_I18N_EN,
            change_password: CHANGE_PASSWORD_I18N_EN,
            common: COMMON_I18N_EN,
            uploaded_comments_tab: UPLOADED_COMMENTS_TAB_I18N_EN,
            feed_comments: FEED_COMMENTS_I18N_EN,
            filter: FILTER_I18N_EN,
            comment_filter: {
              relevance_filter: RELEVANCE_FILTER_I18N_EN
            }
          },
          app: APP_I18N_EN
        },
        topics: {
          topics: TOPICS_I18N_EN,
          components: {
            add_topic:ADD_TOPIC_I18N_EN,
            choose_data_source_modal: CHOOSE_DATA_SOURCE_MODAL_I18N_EN,
            upload_data_topic_details_modal: UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_EN,
            upload_files_modal: UPLOAD_FILES_MODAL_I18N_EN,
            data_summary_modal: DATA_SUMMARY_MODAL_I18N_EN,
            data_summary_with_errors_modal: DATA_SUMMARY_WITH_ERRORS_MODAL_I18N_EN,
            data_summary_section: DATA_SUMMARY_SECTION_I18N_EN,
            error_section: ERROR_SECTION_I18N_EN,
            loading_modal: LOADING_MODAL_I18N_EN,
            remove_rows_confirmation_modal: REMOVE_ROWS_CONFIRMATION_MODAL_I18N_EN,
            data_table_section: DATA_TABLE_SECTION_I18N_EN,
            cancel_topic_creation_modal: CANCEL_TOPIC_CREATION_MODAL_I18N_EN,
            uploaded_files_table_section: UPLOADED_FILES_TABLE_SECTION_I18N_EN,
            edit_topic_modal: EDIT_TOPIC_MODAL_I18N_EN,
            edit_topic: {
              keywords_details_section: KEYWORDS_DETAILS_SECTION_I18N_EN,
              basic_topic_details_section: BASIC_TOPIC_DETAILS_SECTION_I18N_EN
            }
          }
        },
        user_management: {
          components: {
            add_user_account_modal: ADD_USER_ACCOUNT_MODAL_I18N_EN
          }
        },
        shared_components: {
          chart: {
            bubble_chart: BUBBLE_CHART_I18N_EN
          }
        },
        sources: {
          sources: SOURCES_I18N_EN
        }
      },
      common: {
        http: COMMON_HTTP_I18N_EN
      }
    }
  },
  "en-US": { translation: {}},
  'en-SG': { translation: {}}
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: resources,
    lng: navigator.language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
});
  export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js